import styled from 'styled-components'

export const TabsRow = styled.div`
  display: flex;
  width: 100%;
`

export const TabItem = styled.button`
  all: unset;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  box-sizing: border-box;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-right: 1px solid #e5e7eb;
  border-bottom: solid ${({ $active }) => ($active ? '4px #0EA5E9' : '1px #D2D2D2')};
  background: ${({ $active }) => ($active ? '#ffffff' : '#FAFAFA')};

  &:last-child {
    border-right: none;
  }

  &:hover {
    background: #ffffff;
  }
`

export const TabLabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 16px;
  color: #444444;
`

export const TabValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
`

export const TabValue = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  line-height: 36px;
`

export const TabStatusText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ tone }) => (tone === 'success' ? '#4A8C66' : '#D18300')};
`